// extracted by mini-css-extract-plugin
export var connectWalletItem = "bF_hr";
export var loading = "bF_hs";
export var blockName = "bF_ht";
export var iconLoading = "bF_bF";
export var rotate = "bF_c";
export var textLoading = "bF_hv";
export var dotty = "bF_d";